import React, { memo, useCallback } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setIsSidebarOpen, setActiveMobilePanel } from 'Pods/ThreeDStudio/Store/actions/ui'
import { MOBILE_PANEL } from 'Pods/ThreeDStudio/Store/constants'

import { getBreakPoint } from 'Utils/useBreakpoint'

import CollapsedModelStatusCard from './Components/CollapsedModelStatusCard/CollapsedModelStatusCard'
import Header from './Components/Header/Header'
import LibraryContent from './Components/LibraryContent/LibraryContent'
import LinkNav from './Components/LinkNav/LinkNav'
import NotificationsPopover from './Components/NotificationsPopover/NotificationsPopover'
import SettingsButton from './Components/SettingsButton/SettingsButton'
import TermsOfServiceButton from './Components/TermsOfServiceButton/TermsOfServiceButton'
import useGeneratorRunChannel from './Hooks/useGeneratorRunChannel'

function Sidebar() {
  useGeneratorRunChannel()

  const isOpen = useThreeDStudioStore(state => state.ui?.isSidebarOpen)

  const handleToggleSidebar = useCallback(() => {
    setIsSidebarOpen(!isOpen)
  }, [isOpen])

  const handleNavigate = useCallback((type) => {
    // On mobile the opened sidebar covers the workspace, so collapse it after navigation
    if (getBreakPoint(window.innerWidth) === 'xs') {
      setIsSidebarOpen(false)
      if (type === 'model') {
        setActiveMobilePanel(MOBILE_PANEL.VIEWER)
      }
    }

    if (type === 'new') {
      setActiveMobilePanel(MOBILE_PANEL.GENERATE)
    }
  }, [])

  return (
    <nav
      className={classnames('sidebar', isOpen && 'sidebar--opened')}
      aria-label="sidebar"
    >
      <Header
        isOpen={isOpen}
        handleToggleSidebar={handleToggleSidebar}
      />
      <LinkNav isOpen={isOpen} onNavigate={handleNavigate} />
      {isOpen && <LibraryContent onNavigate={handleNavigate} />}
      {!isOpen && <CollapsedModelStatusCard />}
      <div className="sidebar__footer">
        <SettingsButton isOpen={isOpen} />
        {isOpen && <TermsOfServiceButton />}
      </div>
      <NotificationsPopover />
    </nav>
  )
}

export default memo(Sidebar)
